import { spacesSanitizer } from 'utils/sanitizers';

export const parsePhonetoLink = (phone: string) =>
  `+34${spacesSanitizer(phone)}`;
